import { render, staticRenderFns } from "./g-paid-feature.vue?vue&type=template&id=01ea27d6&scoped=true&"
import script from "./g-paid-feature.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-paid-feature.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-paid-feature.vue?vue&type=style&index=0&id=01ea27d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ea27d6",
  null
  
)

export default component.exports